import { Component, Output, EventEmitter, OnInit, AfterContentChecked } from '@angular/core';
import {
	Data, DataLoaderService, Subscription, ResetService,ProgressBarService,
	PriceCalculationService
} from '../expert-service-call.index';
import * as _ from 'lodash';
import { Utils } from '../../../../shared/utils';
import { VehicleInfoService } from '../../../../services/vehicle-info.service';
@Component({
	selector: 'expert-local-options',
	templateUrl: './expert-local-options.template.html',
	styleUrls: ['./expert-local-options.component.css']
})
export class ExpertLocalOptions {
	@Output() notify: EventEmitter<any> = new EventEmitter<any>();
	public localOptions: Data[];
	public localKeyValues: String[] = [];;
	public selected: Data[] = [];
	public standardSelected: Data[] = [];
	public expLocal: Data[] = [];
	public retained = [];
	public expertLocalOptions: any;
	public subscription: Subscription;
	private temp: Data[] = [];
	public vehicleInfo: any;

	constructor(private dataLoaderService: DataLoaderService,private progressService: ProgressBarService,
		private priceCalculationService: PriceCalculationService,private vehicleInfoService: VehicleInfoService, private resetService: ResetService) {
		this.localOptions = this.dataLoaderService.data.options;
		this.vehicleInfo = this.vehicleInfoService.extractData();
		if(this.localOptions.length != 0){
			this.dataLoaderService.flagDictionary.noLocalOptions = false;
		}
	}

	ngOnInit() {
		
		//Retention Service
		this.subscription = this.priceCalculationService.notifyObservableNormalComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "normalLocal") {
				let tempLocal = [];
				if (selectedOption.data[0] != undefined) {
					this.selected = [];
					this.temp = [];
					for (let i = 0; i < selectedOption.data[0].length; i++) {
						this.selected.push(selectedOption.data[0][i].code);
						this.selected = _.uniqBy(this.selected, function (o) {
							return o;
						});
						this.temp.push(selectedOption.data[0][i]);
						// for undo
						tempLocal.push(selectedOption.data[0][i].code);
						// if (selectedOption.data[0][i].tempStdFlag) {
						// 	this.standardSelected.push(selectedOption.data[0][i].code)
						// }
						// else {
						// 	this.selected.push(selectedOption.data[0][i].code);
						// }

						// this.selected = _.uniqBy(this.selected, function (o) {
						// 	return o;
						// });
						// this.standardSelected = _.uniqBy(this.standardSelected, function (o) {
						// 	return o;
						// });
						// this.temp.push(selectedOption.data[0][i]);
					}
					// for undo
					if(!this.dataLoaderService.flagDictionary.undoActivatedForLocal){
						this.dataLoaderService.previousLocalExp= tempLocal;
					}
				}
				else{
					this.selected = [];
					if(!this.dataLoaderService.flagDictionary.undoActivatedForLocal){
						tempLocal=[];
						this.dataLoaderService.previousLocalExp= [];
					}
				}
			}

		});

		// for undo alternative option
		
		this.priceCalculationService.notifyObservableExpertCompLastItem$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertLocal") {
				let tempLocal = [];
				this.selected=[];
				this.temp = [];
				if (selectedOption.data[0] != undefined) {
					for (let i = 0; i < selectedOption.data[0].length; i++) {

						this.selected.push(selectedOption.data[0][i].code);
						this.selected = _.uniqBy(this.selected, function (o) {
							return o;
						});
						this.temp.push(selectedOption.data[0][i]);
						tempLocal.push(selectedOption.data[0][i].code);
					}
					this.dataLoaderService.previousLocalExp= tempLocal;

				} else {
					this.selected = [];
					if(!this.dataLoaderService.flagDictionary.undoActivatedForLocal){
						tempLocal=[];
						this.dataLoaderService.previousLocalExp= [];
					}
				}
				
				this.dataLoaderService.flagDictionary.undoActivatedForLocal= false;
				this.dataLoaderService.flagDictionary.undoActivated= false;
				
				this.progressService.progressBarValidation();
				
			}
		});
		// Undo - End
		// On load		
		this.localOptions.forEach(element => {
			if (element.selected === true) {
				this.expLocal.unshift(element);
			}
		});

		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.expLocal] });
		// this.priceCalculationService.expertModePriceCalculation();
		this.priceCalculationService.normalModePriceCalculation();


		//Reset Service
		this.subscription = this.resetService.notifyObservable$.subscribe(() => {
			this.selected = this.resetService.expLocalCodes;
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocal", data: [this.resetService.expLocal] });
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.resetService.expLocal] });
			this.priceCalculationService.expertModePriceCalculation();

		});
	}
	ngAfterContentChecked() {
		this.localKeyValues = [];
		for (let index = 0; index < this.localOptions.length; index++) {
			if (this.localOptions[index].selected === false) {
				this.localKeyValues.push(((this.localOptions[index].code + " - " + this.localOptions[index].description)));
			}

		}

		for (let j = 0; j < this.localKeyValues.length; j++) {
			for (let i = 0; i < this.selected.length; i++) {

				let item = this.localKeyValues[j].substring(0, this.localKeyValues[j].indexOf(' - '));
				let temp = this.selected[i] + "";
				if (item === temp) {

					this.localKeyValues.splice(Number(j), 1);
				}
			}
		}
	}

	// Set flags to activate undo 
	undoActivate(){
		// for undo operation in alternative screen -start 
		this.dataLoaderService.flagDictionary.undoActivatedForFactory= true;
		this.dataLoaderService.flagDictionary.undoActivated= true;
		// for undo operation in alternative screen -end
	}

	//adds selected local option
	onLocalOptionClick(item) {
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		this.undoActivate() //undo activate
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let localCode;
		localCode = item.substr(0, 3);
		// this.dataLoaderService.expAdd.push(localCode);
		this.expLocal = this.temp;
		let count = 0;
		for (let i = 0; i < this.localOptions.length; i++) {
			if (this.localOptions[i].code == localCode) {
				for (let j = 0; j < this.selected.length; j++) {
					if (localCode != this.selected[j]) {
						count++;
					}
				}
				if (count == this.selected.length) {
					this.dataLoaderService.flagDictionary.expertValidateFlag = true;
					this.dataLoaderService.flagDictionary.expertvalidated = false;
					this.selected.push(item);
					this.expLocal.unshift(this.localOptions[i]);
					this.localOptions[i].selected = true;
				} else {
					this.localOptions[i].selected = false;
				}
			}
		}
		this.dataLoaderService.flagDictionary.migrationFlag = false;
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocal", data: [this.expLocal] });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.expLocal] });
		this.priceCalculationService.expertModePriceCalculation();
		

	}

	clearOptions() {
		this.expertLocalOptions = null;
	}

	// removes the selected local option	
	deleteSelExpLocalOpt(item) {
		this.undoActivate() //undo activate
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let localCode;
		localCode = item.substr(0, 3);
		this.expLocal = this.temp;
		for (let i in this.selected) {
			if (this.selected[i] == localCode) {
				this.selected.splice(Number(i), 1);
			}
		}
		for (let j in this.expLocal) {
			if (this.expLocal[j].code === localCode) {
				// if (this.expLocal[j].selected) {
				// 	this.dataLoaderService.expertRemovedCodes.push(this.expLocal[j]);
				// }
				this.expLocal.splice(Number(j), 1);
				this.dataLoaderService.flagDictionary.expertValidateFlag = true;
				//this.dataLoaderService.flagDictionary.expertvalidated = false;
			}
		}
		let selcFacForRem = [];
		for (let k in this.localOptions) {
			if (this.localOptions[k].selected) {
				selcFacForRem.push(this.localOptions[k]);
			}
		}
		this.priceCalculationService.notifyExpertCompForRemoved({ fromComponent: "expertLocal", data: [selcFacForRem] });
		for (let k in this.localOptions) {
			if (this.localOptions[k].code === localCode) {
				this.localOptions[k].selected = false;
			}
		}
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocal", data: [this.expLocal] });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.expLocal] });
		// this.priceCalculationService.expertModePriceCalculation();
		this.priceCalculationService.normalModePriceCalculation();
		

	}
	openviewMoreLocal() {
		this.dataLoaderService.flagDictionary.viewMoreFlag = true;
		this.dataLoaderService.flagDictionary.factoryFlag = false;
		this.dataLoaderService.flagDictionary.localFlag = true;
		this.dataLoaderService.flagDictionary.packageFlag = false;
	}

	checkForEGLocalOptions(){
		if(this.isMarketEG()){
			if(this.dataLoaderService.data.options.length>0){
				return false;
			}
			else{
				return true;
			}
		}
	}

	isMarketEG(){
		return Utils.isCountryEG(this.vehicleInfo.orderingMarket);
	}
}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-local-options/expert-local-options.component.ts